export var mixinComponente = {  

  methods: {    

    // COMPONENTE PICK **********************************************************************************************************************************
    pick() {
      let self= this;

      return {
        // devuelvo datos a guardar        
        get({ ctrl, record_aux }) {
          record_aux[ctrl[0]]= ctrl[2];
        },   
                
        // muestro datos
        async set({ctrl, record, ini}) {             
          // si no tiene f, salgo
          if (!ctrl[0]) return;
          
          // si es un ini, actualizo valor del record con el dato del ini
          if (ini) record[ctrl[0]]= typeof ctrl[2]=== "undefined"? "" : ctrl[2];

          // si el valor de ctrl en el record está vacío, inicializo datos y salgo
          if (record[ctrl[0]]=== "" || record[ctrl[0]]=="0") {
            ctrl[2]= "0";
            ctrl[4].comp.valueaux = "";
            return;
          }
    
          // compruebo si existe el campo pick en el record
          // si existe, lo cojo, si no, ejecuto api      
          if (typeof record["name_" + ctrl[0]]!== "undefined") {
            console.log("Obtengo Pick " + ctrl[0] + ": "+record[ctrl[0]]+" del Record, NO de la API... ", record["name_" + ctrl[0]]);
            ctrl[2]= record[ctrl[0]];
            ctrl[4].comp.valueaux = record["name_" + ctrl[0]];
            return;
          }         
       
          // ejecuto api pick
          var args = { tipo: "comp", api: "pick", accion: "get", fn_args: {
              name: ctrl[4].comp.api,
              id: record[ctrl[0]],
              source: ctrl[4].comp.source? ctrl[4].comp.source : ""
            }
          };

        //   pendiente control de errores
          console.log('args pick: ', args);
          var apiResult = await self.$store.dispatch("ajaxRequest", { args: args });
          console.log('apiResult pick: ', apiResult);
          // no he recibido datos
          if (apiResult.sql.error) {
            ctrl[2]= "0";
            ctrl[4].comp.valueaux = "(error " + record[ctrl[0]] + " no encontrado)";
            return;
          }
    
          // he recibido datos          
          ctrl[2]= record[ctrl[0]];
          ctrl[4].comp.valueaux = apiResult.r[0][0][ctrl[4].comp.f_aux];      
          
          // si hemos definido una fn en el schema, la ejecuto pasándole el row
          //if (ctrl.fn) this[ctrl.fn](apiResult.r[0][0]);
        }

      };    
     
    },


    // COMPONENTE PICK MULTIPLE *************************************************************************************************************************
    pick_multiple() {
      let self= this;

      return {       
        //
        get({ ctrl, record_aux }) {
          record_aux[ctrl[0]]= ctrl[2];
        },   

        //
        async set({ctrl, record, ini, forzar=false}) {           
          // si no tiene f, salgo
          if (!ctrl[0]) return; 
          
          // si es un ini, actualizo valor del record con el dato del ini
           if (ini) record[ctrl[0]]= typeof ctrl[2]=== "undefined"? "" : ctrl[2];
          
          // si el valor de ctrl en el record está vacío, inicializo datos y salgo
          if (record[ctrl[0]]== "" || record[ctrl[0]]== "0") {
            ctrl[2]= "0";
            ctrl[4].comp.valueaux = "";
            return;
          }

          // compruebo si existe el campo pick en el record
          // si existe, lo cojo, si no, ejecuto api      
          if (!forzar && typeof record["name_" + ctrl[0]]!== "undefined") {
            console.log("Obtengo Pick Multiple " + ctrl[0] + ": "+record[ctrl[0]]+" del Record, NO de la API... ", record["name_" + ctrl[0]]);
            ctrl[2]= record[ctrl[0]];
            ctrl[4].comp.valueaux = record["name_" + ctrl[0]];
            return;
          }         
          
          // obtengo array de datos y filtro por el valor del ctrl asociado          
          var A_elems = ctrl[4].comp.source? ctrl[4].comp.source : [];
          var elem = A_elems.filter(e => e.id === record[ctrl[4].comp.f2]);
          if (elem.length <= 0) {
            ctrl[2]= "0";
            ctrl[4].comp.valueaux = "";
            return;
          }
          
          // llamada a la API
          var args = {
            tipo: "comp",
            api: "pick",
            accion: "get",
            fn_args: { name: ctrl[4].comp.api, id: record[ctrl[0]], tabla: elem[0].tabla }
          };
      
          var apiResult = await self.$store.dispatch("ajaxRequest", { args: args });      
          if (apiResult.sql.error) {
            ctrl[2]= "0";
            ctrl[4].comp.valueaux = "(error " + record[ctrl[0]] + " no encontrado)";
            return;
          }

          // he recibido datos
          ctrl[2]= record[ctrl[0]];
          ctrl[4].comp.valueaux = apiResult.r[0][0][ctrl[4].comp.f_aux];
          ctrl[4].comp.finder = elem[0].finder;  
          return apiResult.r[0][0];
        },
    
      };    
     
    },


    // COMPONENTE FECHA *********************************************************************************************************************************
    fecha() {
      return { 
        //     
        get({ ctrl, record_aux }) {
          if (ctrl[2]== "") {
            record_aux[ctrl[0]]= "";
            return;
          }
                    
          record_aux[ctrl[0]]= ctrl[2];
        },   
        
        //
        set({ctrl, record, ini}) {        
          if (ini) record[ctrl[0]]= typeof ctrl[2]=== "undefined"? "" : ctrl[2];   
          console.log('RCAA: ', record[ctrl[0]]);  

          if (record[ctrl[0]]!= null && record[ctrl[0]]!= undefined) { 
            if (record[ctrl[0]].includes('0000')) {           
              ctrl[2]= "";
              record[ctrl[0]]= "";
              return;
            }
          } 
                    
          ctrl[2]= record[ctrl[0]]== null? "" : record[ctrl[0]];       
        }        

      }
    },


    // COMPONENTE GEOLOCALIZACIÓN ***********************************************************************************************************************
    geo() {
      //let self= this;

      return { 
        //     
        get({ ctrl, record_aux }) {
          record_aux[ctrl[0]]= ctrl[2];
        },   
        
        //
        set({ctrl, record, ini}) {  
          if (ini) record[ctrl[0]]= typeof ctrl[2]=== "undefined"? "" : ctrl[2];
          ctrl[2]= record[ctrl[0]];
        }       

      }
    },


    // COMPONENTE OBSERVACIONES *************************************************************************************************************************
    obs() {
      return {   
        //  
        get({ ctrl, record_aux }) {
          record_aux[ctrl[0]]= ctrl[2];
          //record[schema.f]== schema.comp.value + '\n' + schema.value;
        },   
        
        //
        set({ctrl, record, ini}) {  
          if (ini) record[ctrl[0]]= typeof ctrl[2]=== "undefined"? "" : ctrl[2];
          ctrl[2]= record[ctrl[0]];
        }      

      }
    },


    // COMPONENTE OBSERVACIONES 3 ***********************************************************************************************************************
    obs3() {
      let self= this;
      let fieldAnterior='';
      let A_datos=[];
      
      return {  
        //   
        // get({ ctrl, schema, record_aux }) { 
        get({ ctrl, record, record_aux }) { 
          ctrl[4].comp.valueaux=ctrl[4].comp.valueaux.trim();
          if (ctrl[4].comp.valueaux== "") return;

         // obtengo el f donde guardar datos según el ROL   
          var field= ctrl[4].comp.fields[self.$store.state.G.ROL];

          // sustituyo los corchetes por parentesis
          var vaux= ctrl[4].comp.valueaux.slice().replace(/\[/g, "(");
          vaux= vaux.replace(/\]/g, ")");

          // monto cadena a guardar en bd
          record_aux[field]= self.identificacion() + " " + vaux +"\n"+ record[field];   
        },

       

        set({ctrl, schema, record}) {
           A_datos=[];
           ctrl[4].comp.valueaux= ""
           let fields=ctrl[4].comp.fields;
           fieldAnterior='';
          
           // Recopilo datos
           for (const rol in fields){
               let rolField=fields[rol]
               this.recopila_fields(ctrl,schema,record,rol,rolField)
           }
           // Orden descendente
           A_datos.sort((x, y) => y.orden - x.orden);

           // orientacion y no repertir nombres
           let nameAnterior=''
           let orient='right'
           A_datos.forEach(item=>{
             if (nameAnterior==item.name) {
                 item.nameVista=''
                 item.orient=orient
             } else {
               nameAnterior=item.name
               item.nameVista=item.name
               orient=orient=='right'?'left':'right'
               item.orient=orient
             }

           })
         
           ctrl[2]=A_datos
        
          //
        // set({ctrl, schema, record, ini}) {
          // // campo que se muestra
          // ctrl.comp.valueaux= "";   

          // var fields= ctrl.comp.fields; 
          // // paso los datos del record a todos los campos de 'fields'                   
          // for (const field in fields) {
          //   if (ini) record[fields[field]]= typeof schema[fields[field]].ini=== "undefined"? "" : schema[fields[field]].ini;
          //   schema[fields[field]].value= record[fields[field]];         
          // }          
         
        },  
        
        recopila_fields(ctrl,schema,record,rol,rolField){
         
          if (!record[rolField])             return;
          if (fieldAnterior==rolField)       return;
          if (record[rolField]=='')          return;

          fieldAnterior=rolField;
          let ar = record[rolField].split("[");
          if (ar) ar.shift();


          if (ar) {
            ar.forEach(item => {
              // los item quedan asi: item=Lourdes P 18:18 14-6-2017] ** POST-CIERRE: Expediente de prueba, se procede a anular
              let A_idTexto = item.split("]");            
              let texto = A_idTexto[1];
              let dia, hora, name, pos;
  
              // get dia
              pos = A_idTexto[0].lastIndexOf(" ");
              dia = A_idTexto[0].slice(pos + 1);
  
              // elimino dia y me quedo con name y hora
              A_idTexto[0] = A_idTexto[0].slice(0, pos);
  
              // saco hora
              pos = A_idTexto[0].lastIndexOf(" ");
              hora = A_idTexto[0].slice(pos + 1);
  
              // elimino hora y me queda name
              A_idTexto[0] = A_idTexto[0].slice(0, pos);
              name = A_idTexto[0].slice(0, pos);
              // en A_idTexto[0] me queda el nombre
              let A_hora = hora.split(":");           
              let A_dia = dia.split("-");                     
              let fecha_date = new Date(
                A_dia[2],
                A_dia[1] - 1,
                A_dia[0],
                A_hora[0],
                A_hora[1],
                0,
                0,
                0
              );
             
              A_datos.push({
                dia: dia,
                hora: hora,
                name: name,
                texto: texto,
                // para oredenar ascendente o descendente
                orden: fecha_date.getTime(),
                color: rol
              });
              
            });
          }





        }
        
      }

    },


    // COMPONENTE CONTROL DE CAMBIOS ***********************************************************************************************************************
    tcc() {
      //let self= this;

      return {     
        get({ ctrl, record_aux }) {
          record_aux[ctrl[0]]=ctrl[4].comp.valueaux+ctrl[2];
        },

        //        
        set({ctrl, record, ini}) {
          if (ini) record[ctrl[0]]= typeof ctrl[2]=== "undefined"? "" : ctrl[2];
          ctrl[4].comp.valueaux="";
          ctrl[2]= record[ctrl[0]];
        }     
      }

    },


    // COMPONENTE IMAGEN ***********************************************************************************************************************
    img() {
      let self= this;

      return {     
        get({ ctrl, record_aux }) {
          if (!ctrl[0]) return;    
          //console.log('FILES: ', ctrl.comp.files);            
          record_aux[ctrl[0]]= ctrl[4].comp.files;  
        },

        //
        async set({ctrl, record, ini}) { 
          // si tiene una url inicial, la guardo y salgo 
          if (ini) {
            ctrl[2]= typeof ctrl[2]=== "undefined"? "" : ctrl[2];
            return;
          }
          
          // lamada API para obtener la url de la imagen
          let args = { tipo:'fnc', accion: 'imagendb', fn_args: { accion:'get', tip:ctrl[4].comp.tip, tip_id:record.id }};          
          let apiResult = await self.$store.dispatch("ajaxRequest", { args: args });
          
          // si no tiene imagen blanqueo datos
          if (apiResult.sql.error||(!apiResult.sql.error && apiResult.r[0]== '')) {
            ctrl[2]= "";
            return;
          }
          
          // guardo url
          ctrl[2]= self.$store.state.G.url_tmp + apiResult.r[0];          
        }     
      }

    }
   
  }
};
